import { useSetState, useRequest, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'
import {
  echoformData
  // transformData
} from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import jobStore from '@/store/components/entryJob'
import { formatNameArrayWithConfig } from '@/utils'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const HealthCertificate: React.FC<any> = ({
  visible,
  title,
  formInfo,
  belongCode,
  publicForm,
  onCancel,
  modalData
}) => {
  const {
    runSaveDynamicFielDetail,
    runDeleteDynamicFielDetail,
    hrmDynamicFielDetailLoading,
    deleteDynamicFielDetailLoading,
    status,
    editItem
  } = modalData
  const [formIt] = Form.useForm()
  const { employeeIds } = useLocalObservable(() => jobStore)
  const [{ randomForm }, setState] = useSetState<any>({
    randomForm: null
  })
  const onFinish = (fieldValues: any) => {
    if (hrmDynamicFielDetailLoading || deleteDynamicFielDetailLoading) return
    // const { echo_info }: any = transformData(publicForm, fieldValues)
    // console.log(echo_info, 'echo_info', publicForm, fieldValues)

    const { formattedData } = formatNameArrayWithConfig({
      formConfig: { formInfo },
      formData: fieldValues
    })

    const values_info = {
      employee_id: employeeIds?.length > 0 ? employeeIds[0] : null,
      id: editItem?.id || null,
      employee_dynamic_field_group_code: belongCode,
      field_value: { ...formattedData }
    }
    console.log(values_info, 'values_info')
    runSaveDynamicFielDetail(values_info)
  }

  useDeepCompareEffect(() => {
    const { info_new: dynamic_info_item }: any = echoformData(publicForm, editItem)
    const rowInfo = {
      ...editItem,
      ...dynamic_info_item
    }
    console.log('dynamic_info_item--rowInfo->>>', rowInfo)
    formIt.setFieldsValue(rowInfo)
    setState({ randomForm: Math.random() })
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const fields = editItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteDynamicFielDetail(ids)
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }
  return (
    <HPopup
      title={title}
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      <div className='income-tax-declaration-popup'>
        <NewEditForm
          formInst={formIt}
          formInfo={formInfo}
          onFinish={onFinish}
          randomForm={randomForm}
          formButtons={getFormButtons(modalData?.status === 'Edit')}
        />
      </div>
    </HPopup>
  )
}

export default observer(HealthCertificate)
